module.exports = __webpack_public_path__ + "portal-static/img/user_student.c85ae9e3.png";